/* eslint-disable import/prefer-default-export */
import baseFetch from '../baseFetch';

export const fetchPremiumPerks = () => baseFetch('/promotions/perks?brand=sl');
